import React from 'react';
import { Button } from '../../../../common/components';
import { useSelector } from 'react-redux';
import { MedicalQuestionContainer } from '../MedicalQuestionContainer/MedicalQuestionContainer';
import './InactiveQuestion.scss';
import { Alert } from 'react-bootstrap';

const getAnswer = (answerText, bmiData) => {
  if (!bmiData) {
    return answerText;
  }
  if (!bmiData.isMetricSystem) {
    return `${bmiData.height1}ft ${bmiData.height2}in | ${bmiData.weight1}st ${
      bmiData.weight2
    }lbs`;
  }

  return `${bmiData.height1}cm | ${bmiData.weight1}kgs`;
};

export const InactiveQuestion = ({
  declarationNumber,
  conditionNumber,
  questionNumber,
  isEditingAnswer,
  onEditAnswer,
  text,
  answerText,
  bmiData,
  warning,
}) => {
  const { isSubmitting, isRetrievingQuestion } = useSelector((state) => state.screening);

  const answer = getAnswer(answerText, bmiData);

  const editQuestion = () => {
    onEditAnswer(declarationNumber, conditionNumber, questionNumber);
  };
  return (
    <MedicalQuestionContainer
      button={
        <Button
          size={'xs'}
          bsStyle="secondary"
          isLoading={isEditingAnswer && isRetrievingQuestion}
          disabled={isSubmitting}
          label="Edit"
          handleClick={editQuestion}
        />
      }
    >
      <div className={'inactive-question'}>
        {text}
        {warning && <Alert bsStyle={'warning'}>{warning}</Alert>}
        <span className={'inactive-question--answer'}>{answer}</span>
      </div>
    </MedicalQuestionContainer>
  );
};
